import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import useTranslate from '../../hooks/useTranslate';

const RefundPolicyLink = ({ lang = 'en', text, className }) => {
    const t = useTranslate();
    const title = text ? text : t('refund-policy');
    switch (lang) {
        default:
            return (
                <Link to="/refund-policy" target="_blank" className={classNames({ [className]: className !== undefined })}>
                    {title}
                </Link>
            );
    }
};

export default RefundPolicyLink;
